import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const propTypes = {
  skin: PropTypes.oneOf(['standard', 'product', 'gallery', 'circular']),
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
  background: PropTypes.oneOf(['standard', 'translucent']),
  imageWidth: PropTypes.oneOf(['standard', 'full-bleed']),
  imageShadow: PropTypes.bool
};
const StandardTile = createComponent({
  displayName: 'StandardTile',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(_ref) {
      let {
        skin,
        layout,
        background,
        imageWidth,
        imageShadow
      } = _ref;
      const classesSet = new Set(['swan-standard-tile']);
      if (skin !== 'standard') classesSet.add("swan-standard-tile-skin-".concat(skin));
      if (layout === 'horizontal') classesSet.add('swan-standard-tile-horizontal');
      if (background === 'translucent' && skin === 'gallery') classesSet.add('swan-standard-tile-background-translucent');
      if (imageWidth === 'full-bleed' && skin === 'product') classesSet.add('swan-standard-tile-full-bleed');
      if (imageShadow === false && skin === 'gallery') classesSet.add('swan-standard-tile-hide-image-shadow');
      return classesSet;
    }
  }
});
StandardTile.defaultProps = {
  skin: 'standard',
  layout: 'vertical',
  imageWidth: 'standard'
};
export { StandardTile };